import { render, staticRenderFns } from "./AmeldingFormPaycheck.vue?vue&type=template&id=c2bcb5ce&scoped=true&"
import script from "./AmeldingFormPaycheck.vue?vue&type=script&lang=ts&"
export * from "./AmeldingFormPaycheck.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingFormPaycheck.vue?vue&type=style&index=0&id=c2bcb5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bcb5ce",
  null
  
)

export default component.exports